
import AuthModule from '../../store/auth.module'
import user from '../../model/user'
import {defineComponent, ref } from 'vue'
import message from '../../model/message'
import response from "@/model/response";
import { useI18n } from 'vue-i18n';

export default defineComponent({
    setup() {
      const {t} = useI18n({useScope:'global'})
        const savehistory = ref(false);
        const storageperiod = ref({label:t('events.day1'), value:0})
        const loading = ref(false);
        const message = ref("");
        const successful = ref(false);

        return {
            t,
            savehistory,
            storageperiod,
            loading,
            message,
            successful,
            options: [
         {label:t('events.day1'), value:0},
        {label:t('events.days3'), value:1},
        {label:t('events.days7'), value:2},
        {label:t('events.days14'), value:3},
        {label:t('events.days30'), value:4}
      ]
        }
    },
computed: {
  currentUser():user {
      return AuthModule.currentUser;
    },
  },
  mounted():void {
    if (!this.currentUser) {
      this.$router.push('/login');
    }
    else{
        this.savehistory = this.currentUser.savehistory
        this.storageperiod = this.options[this.currentUser.storageperiod]
    }
  },
  methods: {
    handleUpdate() {
      this.message = "";
      this.successful = false;
      this.loading = true;
      let data:user = {} as user;
      data.savehistory = this.savehistory
      data.storageperiod = this.storageperiod.value
      AuthModule.updatehistory(data).then(
        (data:response) => {
          this.message = (data.body as message).message;
          if (data.statusCodeValue==200)
            this.successful = true;
          else
            this.successful  =  false;
        //  this.successful = true;
          this.loading = false;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
  },
},
})
